<template>
    <el-dialog width="95%" :visible="isShow" @close="hide" top="5vh" append-to-body :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="flex" style="height: 600px">
            <div style="overflow: auto;max-width: 40%">
                <div :style="'width:'+(form.intOrient==2?pageSize.height:pageSize.width)+';height:'+(form.intOrient==2?pageSize.width:pageSize.height)" style="border: 1px solid #d7d7d7">
                    <ul tabindex="-1" v-key-down-design="activeItem" class="design-area">
                        <li :key="index"
                            v-for="(item, index) in designList"
                            v-drag-design:[index]="dragDesignEvent"
                            :class="{active:index===activeIndex}"
                            class="design-item"
                            :style="switchStyle(item,activeItem)">
                            <template>
                                <span v-if="item.type==='text'">{{item.label}}</span>
                                <span v-else-if="item.type==='image'">
                                <img :src="item.label" alt="图片">
                            </span>
                                <div v-else-if="item.type==='line'"
                                     :style="'width:'+item.width+'px;height:'+item.height+'px;border-'+(item.width>item.height?'bottom':'right')+': '+item.lineWidth+'px solid '+item.lineColor+';'">
                                </div>
                                <div v-else style="font-size: 12px">{{item.label}}</div>
                            </template>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="flex-full control-area">
                <div class="current-field" v-show="activeIndex>-1">
                    <h5>当前字段设置</h5>
                    <div>
                        <label>当前序号<input :disabled="true" type="text" v-model="activeIndex"></label>
                        <label>宽度<input v-model.number="activeItem.width" placeholder="宽度"></label>
                        <label>高度<input v-model.number="activeItem.height" placeholder="高度"></label>
                        <label>左边距<input v-model.number="activeItem.left" placeholder="左边距"></label>
                        <label>上边距<input v-model.number="activeItem.top" placeholder="上边距"></label>
                        <label>值设定<input :disabled="activeItem.label!=='自定义'" v-model="activeItem.value" placeholder="值设定，变量用{{}}包裹"></label>
                        <label>显示条件<input  v-model="activeItem.showed" placeholder="表达式"></label>
                        <label>字体大小<input  v-model="activeItem.fontSize" placeholder="字体大小"></label>
                        <label>字体颜色<input  v-model="activeItem.color" placeholder="字体颜色"></label>
                        <label>左右排列<input  v-model="activeItem.textAlign" placeholder="左右排列"></label>
                        <label>行高<input  v-model="activeItem.lineHeight" placeholder="行高"></label>
                        <label>字体粗细<input  v-model="activeItem.fontWeight" placeholder="字体粗细"></label>
                        <label v-if="activeItem.type==='barCode'">条形码类型
                            <select v-model="activeItem.codeType">
                                <option value="128A">128A</option>
                                <option value="128B">128B</option>
                                <option value="128C">128C</option>
                                <option value="128AUTO">128AUTO</option>
                            </select>
                        </label>
                        <template v-if="activeItem.type==='line'">
                            <label>
                                线条类型
                                <select v-model="activeItem.lineStyle">
                                    <option value="0">实线</option>
                                    <option value="1">虚线</option>
                                </select>
                            </label>
                            <label>线条宽度<input type="text" v-model="activeItem.lineWidth" placeholder="线条宽度"></label>
                            <label>线条颜色<input type="text" v-model="activeItem.lineColor" placeholder="线条颜色"></label>
                        </template>
                        <button type="button" @click="removeDesignItem">移除</button>
                    </div>
                </div>
                <div>
                    <h5>全局配置</h5>
                    <div>
                        <label>面单宽度<input v-model="pageSize.width" disabled type="text"></label>
                    </div>
                    <div>
                        <label>面单高度<input v-model="pageSize.height" disabled type="text"></label>
                    </div>
                    <div>
                        <label>单位换算<input v-model="pageSize.conversion" disabled type="text"></label>
                    </div>
                </div>
                <div>
                    <h5>内置字段</h5>
                    <label v-for="item in canAddItems">{{item.label}}<button @click="createItem(item)" type="button">添加</button></label>
                </div>
                <div>
                    <h5>自定义</h5>
                    <div>
                        <label>
                            <select v-model="canAddTypesActive">
                                <option v-for="item in canAddTypes" :value="item.value">{{item.label}}</option>
                            </select>
                        </label>
                        <button type="button" @click="createItem({type:canAddTypesActive})">添加</button>
                    </div>
                </div>
                <div>
                    <h5>测试数据(预览效果用)</h5>
                    <div>
                        <label><textarea style="width: 100%;height: 60px;box-sizing: border-box" v-model="testData"></textarea></label>
                    </div>
                </div>
                <div>
                    <el-button size="mini" @click="hide">取消</el-button>
                    <el-button type="primary" @click="save" size="mini">保存</el-button>
                </div>
            </div>
            <div style="overflow-x: auto;max-width: 40%;overflow-y: hidden">
                <div class="preview-area" :style="'width:calc('+pageSize.width+' + 20px);height:100%;'" v-print-preview="previewScript"></div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
    import printPreview from "@/directives/printPreview"
    import DPrint from "@/common/print/print-4.0.0";
    import dragDesign from '@/directives/dragOnDesignView';
    import keyDownDesign from '@/directives/keyDownOnDesignView';
    const tem=new DPrint.WindowLODOP({});
    export default {
        props:{
            templateData:Object
        },
        directives:{
            printPreview,
            dragDesign,
            keyDownDesign
        },
        data() {
            return {
                form:{...this.templateData},
                isShow:true,
                testData:`[{"accountName":"","cargoName":"1","cargoPack":"纸","cargoPiece":"1","cargoVolume":"0.36","cargoWeight":"60.00","consigneeAddress":"上海上海市青浦区徐泾镇明珠路22号","consigneeCity":"上海市","consigneeCompany":"顺丰快递","consigneeDistrict":"青浦区","consigneeMobilePhoneNumber":"18701777021/021-6212999","consigneeName":"测试","consigneeProvince":"上海","consigneeTelephoneNumber":"187****7021/****","consigneeTown":"上海上海市青浦区徐泾镇明珠路22号","consigneeTownCode":"310118008","consignerAddress":"浙江省宁波市慈溪市龙山镇龙山所村329国道旁","consignerCity":"宁波市","consignerCompany":null,"consignerDistrict":"慈溪市","consignerMobilePhoneNumber":"15821169916","consignerName":"测试","consignerProvince":"浙江省","consignerTelephoneNumber":"","consignerTown":"龙山镇","currencyName":"CNY","customerCode":"641136712","customerName":"异地调货测试","filterStatus":"SIEVE_ACCEPT","insuranceAmount":"2000.00","isPicPackage":"否","letthem":"签收单原件返回","markerPen":"上海 7D1","orderCode":"O2019120621300599209450253","orderCreateReturn":null,"orderCreateStatus":"Y","orderResourece":"systemImport","orderTriage":"EXP","orderType":"EWAYBILL","otherExpenses":"0.00","outSend":null,"parentOrderNumber":null,"parentWaybillNumber":null,"paymentMethod":"到付","picPackageType":"N","platformOrderResourece":"RUIFA","printSerialNos":"0001","productCode":"3.60特重件【31-60kg】","receivingtoPointid":null,"remark":"文松，你英雄联盟什么段位了","serialNumber":"0001","shipMethod":"PICKUPSTAIRS","spliteMergeType":null,"thecollectingAccount":"","thecollectingWay":"NOTHING","thecollectingWayMoney":"0.00","totalCargoVolume":"0.36","totalCargoWeight":"60.00","totalPiece":"1","waybillNumber":"8550112456","weightBubbleRate":"0"},{"accountName":"","cargoName":"1","cargoPack":"纸","cargoPiece":"1","cargoVolume":"0.36","cargoWeight":"60.00","consigneeAddress":"上海上海市青浦区徐泾镇明珠路22号","consigneeCity":"上海市","consigneeCompany":"顺丰快递","consigneeDistrict":"青浦区","consigneeMobilePhoneNumber":"18701777021/021-6212999","consigneeName":"测试","consigneeProvince":"上海","consigneeTelephoneNumber":"187****7021/****","consigneeTown":"上海上海市青浦区徐泾镇明珠路22号","consigneeTownCode":"310118008","consignerAddress":"浙江省宁波市慈溪市龙山镇龙山所村329国道旁","consignerCity":"宁波市","consignerCompany":null,"consignerDistrict":"慈溪市","consignerMobilePhoneNumber":"15821169916","consignerName":"测试","consignerProvince":"浙江省","consignerTelephoneNumber":"","consignerTown":"龙山镇","currencyName":"CNY","customerCode":"641136712","customerName":"异地调货测试","filterStatus":"SIEVE_ACCEPT","insuranceAmount":"2000.00","isPicPackage":"否","letthem":"签收单原件返回","markerPen":"上海 7D1","orderCode":"O2019120621300599209450253","orderCreateReturn":null,"orderCreateStatus":"Y","orderResourece":"systemImport","orderTriage":"EXP","orderType":"EWAYBILL","otherExpenses":"0.00","outSend":null,"parentOrderNumber":null,"parentWaybillNumber":null,"paymentMethod":"到付","picPackageType":"N","platformOrderResourece":"RUIFA","printSerialNos":"0001","productCode":"大件快递3.60","receivingtoPointid":null,"remark":"文松，你英雄联盟什么段位了","serialNumber":"0001","shipMethod":"PICKUPSTAIRS","spliteMergeType":null,"thecollectingAccount":"","thecollectingWay":"NOTHING","thecollectingWayMoney":"0.00","totalCargoVolume":"0.36","totalCargoWeight":"60.00","totalPiece":"1","waybillNumber":"8550112456","weightBubbleRate":"0"}]`,
                designList:[],
                control:{

                },
                activeItem:{},
                activeIndex:-1,
                dragDesignEvent:{
                    mousedown(activeIndex){
                        this.activeIndex=activeIndex;
                    },
                    mousemove({offsetX,offsetY}){
                        this.activeItem.left+=offsetX;
                        this.activeItem.top+=offsetY;
                    }
                },
                canAddTypesActive:"text",
                canAddTypes:[
                    {label:"文本",value:"text"},
                    {label:"html",value:"html"},
                    {label:"线条",value:"line"},
                    {label:"图片",value:"image"},
                    {label:"黑底白字",value:"blackBackgroundWhiteFont"},
                    {label:"条形码",value:"barCode"},
                    {label:"二维码",value:"QRCode"}
                ],
                canAddItems:[
                    {label:"产品类型",value:"{{productCode==='RCP'?'大件快递3.60':productCode}}"},
                    {label:"收件公司",value:"{{consigneeCompany}}"},
                    {label:"外发标识",value:"{{outSend}}"},
                    {label:"代收识别",value:"代{{thecollectingWayMoney}}",type:"blackBackgroundWhiteFont"},
                    {label:"到付识别",value:"{{paymentMethod}}",type:"blackBackgroundWhiteFont"},
                    {label:"家具送装",value:"家具送装",type:"blackBackgroundWhiteFont"},
                    {label:"打印时间",value:"{{new Date().toLocaleString()}}"}
                ]
            }
        },
        computed:{
            fixedDesignList(){
                return this.designList.filter((val,key)=>key!==this.activeIndex)
            },
            pageSize(){
                return {
                    width:this.form.width+"mm",
                    height:this.form.height+"mm",
                    conversion:this.form.conversion
                }
            },
            previewScript(){
                return {
                    render:{
                        width:this.pageSize.width,
                        height:this.pageSize.height,
                        conversion:100/380,//毫米像素比,
                        intOrient:this.form.intOrient,
                        list:this.designList
                    },
                    testData:JSON.parse(this.testData)
                }
            }
        },
        watch:{
            activeItem:{
                deep:true,
                handler(){
                    this.$set(this.designList,this.activeIndex,{...this.activeItem})
                }
            },
            activeIndex(index){
                this.activeItem={...this.designList[index]};
            }
        },
        methods:{
            hide(){
                this.$emit("hide")
            },
            save(){
                this.$emit("hide");
                this.$emit("save",JSON.stringify(this.designList))
            },
            switchStyle(item){
                const {left,top,width,height}=item;
                tem.scale=100/380;
                const isActive=item===this.activeItem;
                return "left:"+tem.aU(left)+";top:"+tem.aU(top)+";width:"+tem.aU(width)+";height:"+tem.aU(height)+";"+tem.initStyle(this.filterObject(item,Boolean));
            },
            filterObject(obj,filter){
                const newObj={};
                for(let key in obj){
                    if(obj.hasOwnProperty(key)&&filter(obj[key],key)){
                        newObj[key]=obj[key]
                    }
                }
                return newObj
            },
            boxLimit(item){

            },
            createItem(item){
                this.designList.push({
                    label:"自定义",
                    value:"自定义",
                    type:"text",
                    showed:"",
                    width:200,
                    height:50,
                    top:0,
                    left:0,
                    codeType:"",

                    fontFamily:"微软雅黑",
                    fontSize:"12",
                    color:"#333",
                    fontWeight:"",
                    fontStyle:"",
                    textAlign:"",
                    lineHeight:"",

                    lineStyle:"0",
                    lineWidth:"2",
                    lineColor:"#000",
                    ...item
                })
            },
            removeDesignItem(){
                this.designList.splice(this.activeIndex,1);
                this.activeIndex=Math.min(this.activeIndex,this.designList.length-1);
            }
        },
        mounted(){
            if(typeof this.form.content==="string"){
                try {
                    this.designList = JSON.parse(this.form.content||"[]");
                }catch (e) {
                    this.designList=[]
                }

            }
            if(!this.designList.length){
                this.designList=[];
            }
        }
    }
</script>
<style scoped>
    .flex{display: flex}
    .flex-full{flex: 1}
    .design-area{position: relative;width: 100%;height: 100%}
    .design-area:focus{background-color: #eee}
    .design-item{box-sizing: border-box;border: 1px solid #d7d7d7;position: absolute}
    .design-item.active{border: 1px solid #ffb100;outline: none}
    .design-item:focus{border: 1px solid #ff5b00;outline: none}
    .preview-area{border:1px solid #d7d7d7;}
    .control-area{overflow: auto}
    .control-area>div{background-color: #f5f5f5;margin-bottom: 15px}
    .control-area h5{line-height: 33px;padding: 0 12px;border-bottom: 1px solid #d7d7d7;color: #333}
    .control-area .current-field label{margin-right: 15px}
    .control-area input{width: 70px;border-radius: 4px;outline: none;border: 1px solid #d7d7d7;margin-left: 6px}
    .current-field{}
    .design-area *{box-sizing: border-box}
    .design-area img{max-width:100%;max-height:100%}
    .design-area canvas{width:100%!important;height:100%!important}
</style>
